export enum CollectionDetailSortOption {
  RecentlyAdded = 'recentlyAdded',
  VerseKey = 'verseKey',
}

export enum CollectionListSortOption {
  RecentlyUpdated = 'recentlyUpdated',
  Alphabetical = 'alphabetical',
}
